/**
 * Created by Ding on 13/07/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Row, Button, Form, Select, Input, DatePicker } from 'antd';
import Moment from 'moment';

const Option = Select.Option;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;


class CandidateForm extends Component {

    static defaultProps = {
        statuses: [],
    };

    static propTypes = {
        form: PropTypes.object.isRequired,
        statuses: PropTypes.array,
        handleSubmit: PropTypes.func.isRequired,
    };

    onSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };

        return (
            <div className="search-bar">
                <Form onSubmit={this.onSubmit}>
                    <div className="search-bar-inputs">
                        <Row>
                            <FormItem
                                {...formItemLayout}
                                className="search-bar-form-item"
                                label="姓名:"
                            >
                                {getFieldDecorator('name')(
                                    <Input placeholder="请输入" />,
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                className="search-bar-form-item"
                                label="推荐日期:"
                            >
                                {getFieldDecorator('createTime')(
                                    <RangePicker
                                        format="YYYY-MM-DD"
                                        placeholder={['开始时间', '结束时间']}
                                        showToday
                                        style={{ width: '100%' }}
                                        allowClear
                                    />,
                                )}
                            </FormItem>
                        </Row>

                        <Row>
                            <FormItem
                                {...formItemLayout}
                                className="search-bar-form-item"
                                label="推荐职位:"
                            >
                                {getFieldDecorator('jobTitle')(
                                    <Input placeholder="请输入" />,
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                className="search-bar-form-item"
                                label="职位处理人:"
                            >
                                {getFieldDecorator('recruiterName')(
                                    <Input placeholder="请输入" maxLength="20" />,
                                )}
                            </FormItem>

                        </Row>
                        <Row>
                            {this.props.statuses && this.props.statuses.length > 0 && <FormItem
                                {...formItemLayout}
                                className="search-bar-form-item"
                                label="推荐状态:"
                            >
                                {getFieldDecorator('status')(
                                    <Select placeholder="请选择" allowClear>
                                        <Option value="">请选择</Option>
                                        {this.props.statuses.map(item => (
                                            <Option
                                                key={item.code.toString()}
                                                value={item.code.toString()}
                                            >
                                                {item.desc}
                                            </Option>
                                        ))}
                                    </Select>,
                                )}
                            </FormItem>}
                        </Row>
                    </div>

                    <div className="search-bar-submit">
                        <Button type="primary" htmlType="submit">筛选</Button>
                    </div>
                </Form>
            </div>
        );
    }
}

// TODO: show options conditionally, not Select

export default Form.create({
    mapPropsToFields: props => ({
        name: { value: props.name },
        createTime: {
            value: (props.createTimeStart && props.createTimeEnd) ?
                [Moment(props.createTimeStart), Moment(props.createTimeEnd)] : null,
        },
        jobTitle: { value: props.jobTitle },
        status: { value: props.status || undefined },
    }),
})(CandidateForm);
